import { introductionTypeQuestion, introductionBtn, customIntroTypeQuestion } from "constants/questionTypes";

// Base intro screens that can be reused across configurations
const introScreens = {
  welcome: {
    intro_id: 1,
    buttonText: "Start",
  },
  about: {
    intro_id: 2,
    buttonText: "Next",
  },
  privacy: {
    intro_id: 3,
    buttonText: "Next",
  },
  agreement: {
    intro_id: 4,
    buttonText: "I agree",
  },
  // Hockey specific intros
  hockeyWelcome: {
    intro_id: 6,
    buttonText: "Start",
  },
  // Additional intro screens
  participantsAgreement: {
    intro_id: 7,
    buttonText: "I agree",
  },
  specialAgreement: {
    intro_id: 5,
    buttonText: "I agree", 
  },
  // New CFMWS specific intro
  cfmwsIntro: {
    intro_id: 8,
    buttonText: "Start",
  }
};

// Define sequence templates for different organization types
const introSequences = {
  // Standard sequence
  standard: [
    introScreens.welcome,
    introScreens.about,
    introScreens.privacy,
    introScreens.agreement
  ],
  
  // Hockey sequence
  hockey: [
    introScreens.hockeyWelcome,
    introScreens.agreement,
  ],
  
  // Hockey participants sequence
  hockey_participants: [
    introScreens.hockeyWelcome,
    introScreens.agreement,
    introScreens.participantsAgreement
  ],
  
  // Hockey members sequence
  hockey_members: [
    introScreens.hockeyWelcome,
    introScreens.agreement,
  ],
  
  // CFMWS sequence
  cfmws: [
    introScreens.cfmwsIntro,
    introScreens.privacy,
    introScreens.agreement
  ],
};

// Function to build the complete intro sequence for an organization
// Accepts optional custom intro screens from questions payload and default flags
// customScreens: array of custom screens (id, title, contents[])
// defaultIntroFlags: { default_intro: boolean, default_privacy: boolean, default_private_response: boolean }
const buildIntroSequence = (organizationInfo, sortOrder, customScreens = [], defaultIntroFlags = null) => {
  const publicIntro = organizationInfo?.public_intro || 'standard';
  let sequence = [];
  
  // Establish base sequence according to defaults and org type
  if (Array.isArray(customScreens) && customScreens.length > 0) {
    // If custom screens provided, optionally prepend default welcome/privacy per flags
    if (defaultIntroFlags && defaultIntroFlags.default_intro) {
      sequence.push({ ...introScreens.welcome });
    }
    // Include the privacy screen when requested for custom intros
    if (defaultIntroFlags && defaultIntroFlags.default_private_response) {
      sequence.push({ ...introScreens.privacy });
    }
    if (defaultIntroFlags && defaultIntroFlags.default_privacy) {
      sequence.push({ ...introScreens.agreement });
    }
  } else {
    // No custom screens → fall back to predefined sequences
    if (introSequences[publicIntro]) {
      sequence = [...introSequences[publicIntro]];
    } else {
      sequence = [...introSequences.standard];
    }
  }
  
  // Apply special modifications if needed
  if (sortOrder === 160) {
    sequence.push({...introScreens.specialAgreement});
  }
  
  // Apply CFMWS specific intro when sort order is 226
  if (sortOrder === 226) {
    // Override the existing sequence with the CFMWS sequence
    sequence = [...introSequences.cfmws];
  }
  
  // Transform the default sequence into the base list
  const mappedDefaults = sequence.map((screen, index) => {
    const position = index + 1;
    return {
      id: position,
      sort_order: position,
      quesType: introductionTypeQuestion,
      buttonType: introductionBtn,
      intro_type: publicIntro,
      intro_id: screen.intro_id,
      total: position,
      skip: false,
      buttonText: screen.buttonText,
      visualTotal: 0,
      clicked: true,
      response: { response: true },
    };
  });

  // Append custom screens if provided
  let runningPosition = mappedDefaults.length;
  if (Array.isArray(customScreens) && customScreens.length > 0) {
    const mappedCustoms = customScreens.map((c, i) => {
      const position = runningPosition + i + 1;
      return {
        id: position,
        sort_order: position,
        quesType: customIntroTypeQuestion,
        buttonType: introductionBtn,
        intro_type: publicIntro,
        intro_id: c.id,
        title: c.title,
        contents: c.contents,
        total: position,
        skip: false,
        buttonText: 'Next',
        visualTotal: 0,
        clicked: true,
        response: { response: true },
      };
    });
    // Combine
    const combined = [...mappedDefaults, ...mappedCustoms];
    // Add survey_sort_order to last item only
    if (combined.length > 0) {
      combined[combined.length - 1] = {
        ...combined[combined.length - 1],
        survey_sort_order: sortOrder,
      };
    }
    return combined;
  }

  // Add survey_sort_order to last default item if present
  if (mappedDefaults.length > 0) {
    mappedDefaults[mappedDefaults.length - 1] = {
      ...mappedDefaults[mappedDefaults.length - 1],
      survey_sort_order: sortOrder,
    };
  }
  return mappedDefaults;
};

export default buildIntroSequence;